import { FieldStore, ISubFormStore, validateSubForm } from '@tom-ui/utils'
import { makeObservable } from 'mobx'

export class CargoSubFormStore implements ISubFormStore<any> {
  cargoStatus: FieldStore<string | null | undefined>
  commodity: FieldStore<string | null | undefined>

  constructor() {
    this.cargoStatus = new FieldStore<string | null | undefined>(undefined)
    this.commodity = new FieldStore<string | null | undefined>(undefined)

    makeObservable(this)
  }

  validate = () => {
    return validateSubForm(this)
  }

  get data() {
    return {
      cargoStatus: this.cargoStatus.data,
      commodity: this.commodity.data,
    }
  }
}
